module.exports = __webpack_public_path__ + "static/media/confetti.e56a0699.mp3";